export const REQUEST_LOADING = 0;
export const REQUEST_SUCCESSFULL = 1;
export const REQUEST_ERROR = -1;
